let Days = {
    korean: ["일", "월", "화", "수", "목", "금", "토"],
    korean_render: ["월", "화", "수", "목", "금", "토", "일"],
    keyset_render: ["mon", "tue", "wed", "thu", "fri", "sat", "sun"],
    keyset: ["sun", "mon", "tue", "wed", "thu", "fri", "sat"],
    timeset: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22],
    timeset_banned: []
};

export default Days;
